import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { ThemeProvider } from "@mui/material/styles"
import theme from "theme"
import Gallery from "pages/Gallery"

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route index element={<Gallery/>}/>
          </Routes>
        </Router>
      </ThemeProvider>
    </>
  )
}

export default App
